import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from 'src/features/Auth';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'src/app/store';
import { getEnterpriseProfile } from 'src/features/Dashboard';

export interface Props {
  component: React.FC;
}

const TrackingReportPrivateRoute = ({ component: Component }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    dispatch(getEnterpriseProfile());
  }, []);

  return isAuthenticated() ? (
    <Component />
  ) : (
    <Navigate to={`/auth/signin?${params.toString()}`} />
  );
};

export default TrackingReportPrivateRoute;
